import { DOCUMENT } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { SubNavigation, TopLevelNavItem } from '../models';

@Component({
    selector: 'vision2-navigation-mobile',
    templateUrl: './navigation-mobile.component.html',
    styleUrl: './navigation-mobile.component.scss',
    standalone: false,
})
export class NavigationMobileComponent {
    @Input() navData: TopLevelNavItem[];

    document = inject(DOCUMENT);

    mobileTier = 1;
    mobileTierChildren: any[];
    primaryTierItem: any;
    secondaryTierItem: any;
    columnValue: string;

    constructor() {}

    closeMobileMenu() {
        this.mobileTier = 1;
    }

    ngAfterViewInit(): void {
        const offcanvas = this.document.getElementById('offcanvas');
        offcanvas.addEventListener(
            'hidden.bs.offcanvas',
            this.closeMobileMenu.bind(this),
        );
    }

    /**
     * Toggle the mobile tier based on the provided ID.
     * Set the children and parent items accordingly.
     */
    toggleMobileTier(
        id: number,
        children: SubNavigation[],
        parentItem: TopLevelNavItem,
        columnValue?: string,
    ) {
        this.mobileTier = id;
        this.mobileTierChildren = children;

        switch (id) {
            case 1:
                this.primaryTierItem = '';
                this.secondaryTierItem = '';
                break;
            case 2:
                this.secondaryTierItem = '';
                this.primaryTierItem = parentItem || '';
                break;
            case 3:
                this.secondaryTierItem = parentItem || '';
                this.columnValue = columnValue || '';
                break;
        }
    }

    originalOrder(a, b) {
        return 0;
    }
}
